import { useQueries } from "@tanstack/react-query";
import { get } from "aws-amplify/api";
// import { fetchAuthSession } from "aws-amplify/auth";

const fetchLookup = async (path) => {
  const silentLookupFailures = new Set(['/slmlookups/reviewtypes', '/leaseclassifications']);
  try {
    const restOperation = get({ apiName: "colin", path });
    const response = await restOperation.response;

    // Check if the response is actually JSON
    const contentType = response.headers['content-type'];
    if (!contentType || !contentType.includes('application/json')) {
      throw new Error(`Expected JSON but got ${contentType}`);
    }

    return await response.body.json();
  } catch (error) {
    if (!silentLookupFailures.has(path)) {
      console.error(`Request failed for ${path}:`, error);
    }
    return []; // Return empty array so the app doesn't crash
  }
};

const ALL_LOOKUP_QUERIES = [
  // // --- SLM LOOKUPS ---
  // { queryKey: ['lookups', 'sourcecategoryOptions'], path: '/slmlookups/sourcecategory' },
  // { queryKey: ['lookups', 'statuscategoryOptions'], path: '/slmlookups/statuscategory' },
  // { queryKey: ['lookups', 'spaceusecategoryOptions'], path: '/slmlookups/spaceusecategory' },
  // { queryKey: ['lookups', 'broadspaceusecategoryOptions'], path: '/slmlookups/broadspaceusecategory' },
  // { queryKey: ['lookups', 'zoningcategoryOptions'], path: '/slmlookups/zoningcategory' },
  // { queryKey: ['lookups', 'qualitytypecategoryOptions'], path: '/slmlookups/qualitytypecategory' },
  // { queryKey: ['lookups', 'titlebasiscategoryOptions'], path: '/slmlookups/titlebasiscategory' },
  // { queryKey: ['lookups', 'salemethodcategoryOptions'], path: '/slmlookups/salemethodcategory' },
  // { queryKey: ['lookups', 'saledescribercategoryOptions'], path: '/slmlookups/saledescribercategory' },
  // { queryKey: ['lookups', 'incomebasiscategoryOptions'], path: '/slmlookups/incomebasiscategory' },
  // { queryKey: ['lookups', 'areabasiscategoryOptions'], path: '/slmlookups/areabasiscategory' },
  // { queryKey: ['lookups', 'carspacecategoryOptions'], path: '/slmlookups/carspacecategory' },
  
  // // --- LEASE LOOKUPS ---
  // { queryKey: ['lookups', 'leasemethodcategoryOptions'], path: '/slmlookups/leasemethodcategory' },
  // { queryKey: ['lookups', 'leasestatuscategoryOptions'], path: '/slmlookups/leasestatuscategory' },
  // { queryKey: ['lookups', 'leaselevelcategoryOptions'], path: '/slmlookups/leaselevelcategory' },
  // { queryKey: ['lookups', 'leaseoutgoingscategoryOptions'], path: '/slmlookups/leaseoutgoingscategory' },
  // { queryKey: ['lookups', 'rentperannumbasiscategoryOptions'], path: '/slmlookups/rentperannumbasiscategory' },
  // { queryKey: ['lookups', 'rentpersqmbasiscategoryOptions'], path: '/slmlookups/rentpersqmbasiscategory' },
  // { queryKey: ['lookups', 'leaselreviewbasiscategoryOptions'], path: '/slmlookups/leaselreviewbasiscategory' },

  // // --- MISCELLANEOUS LOOKUPS ---
  // { queryKey: ['lookups', 'saleTypes'], path: '/slmlookups/saletypes' },
  // { queryKey: ['lookups', 'leaseTypes'], path: '/slmlookups/leasetypes' },
  // { queryKey: ['lookups', 'streetTypes'], path: '/slmlookups/streettypes' },
  // { queryKey: ['lookups', 'unitTypes'], path: '/slmlookups/unittypes' },
  // { queryKey: ['lookups', 'categoryGroups'], path: '/slmlookups/categorygroups' },
  // { queryKey: ['lookups', 'subRegionOptions'], path: '/slmlookups/subregions' },
  // { queryKey: ['lookups', 'reviewTypeOptions'], path: '/slmlookups/reviewtypes' },
  
  // --- CITYSCOPE / CORE LOOKUPS ---
  { queryKey: ['lookups', 'liftOperatorOptions'], path: '/liftoperators' },
  { queryKey: ['lookups', 'articleCategories'], path: '/articlecategories' },
  { queryKey: ['lookups', 'fileTypes'], path: '/filetypes' },
  // { queryKey: ['lookups', 'withholdingReasons'], path: '/withholdingreasons' },
  { queryKey: ['lookups', 'buildingGradeSourceOptions'], path: '/buildinggradesources' },
  { queryKey: ['lookups', 'buildingGradeOptions'], path: '/buildinggrades' },
  { queryKey: ['lookups', 'classificationOptions'], path: '/classifications' },
  // { queryKey: ['lookups', 'leaseClassificationOptions'], path: '/leaseclassifications' },
  { queryKey: ['lookups', 'countryOptions'], path: '/countries' },
  { queryKey: ['lookups', 'countryCodeOptions'], path: '/countrycodes' },
  { queryKey: ['lookups', 'salutationOptions'], path: '/salutations' },
  { queryKey: ['lookups', 'entityTypeOptions'], path: '/entitytypes' },
  { queryKey: ['lookups', 'positionOptions'], path: '/positions' },
  // { queryKey: ['lookups', 'firstNames'], path: '/firstnames' },
];

const LEGACY_WITHHOLDING_QUERY = {
  queryKey: ['lookups', 'cityscopelookups'],
  path: '/cityscopelookups',
};

const LEGACY_SLM_LOOKUPS_QUERY = {
  queryKey: ['lookups', 'slmlookups'],
  path: '/slmlookups',
};


export function useAllLookups(enabled) {
  // Include legacy cityscope lookups so HOLD Reason can be derived from look_up==='withholding'.
  const queryDefs = [...ALL_LOOKUP_QUERIES, LEGACY_WITHHOLDING_QUERY, LEGACY_SLM_LOOKUPS_QUERY];

  // We map lookup definitions to the structure required by useQueries
  const queriesConfig = queryDefs.map(lookup => ({
    queryKey: lookup.queryKey,
    queryFn: () => fetchLookup(lookup.path),
    // 24 hours stale time—TanStack Query handles checking if the cache needs refreshing
    staleTime: 1000 * 60 * 60 * 24, 
    // Only run these fetches if the 'enabled' flag is true (i.e., user is logged in/app is selected)
    enabled: enabled, 
  }));

  const results = useQueries({ queries: queriesConfig });

  // Re-map the results array back into a simple, named object (e.g., lookups.articleCategories)
  const lookups = {};
  let legacyCityscopeLookups = [];
  let legacySlmLookups = [];
  results.forEach((result, index) => {
    // We use the second item in the queryKey as the object key (e.g., 'articleCategories')
    const key = queryDefs[index]?.queryKey?.[1];
    const rawData = result.data || [];

    if (!key) {
      return;
    }

    if (key === 'cityscopelookups') {
      legacyCityscopeLookups = Array.isArray(rawData) ? rawData : [];
      return;
    }

    if (key === 'slmlookups') {
      legacySlmLookups = Array.isArray(rawData) ? rawData : [];
      return;
    }

    lookups[key] = rawData;
  });

  const mapLegacyLookupList = (group, candidateValueKeys, candidateLabelKeys) => {
    const list = Array.isArray(group?.list) ? group.list : [];

    return list
      .map((option) => {
        if (typeof option === "string") {
          return { value: option, label: option };
        }

        const value =
          candidateValueKeys
            .map((k) => option?.[k])
            .find((v) => v !== undefined && v !== null && String(v) !== "") ??
          "";

        const label =
          candidateLabelKeys
            .map((k) => option?.[k])
            .find((v) => v !== undefined && v !== null && String(v) !== "") ??
          String(value);

        return {
          ...option,
          value,
          label,
        };
      })
      .filter((option) => option.value !== undefined && option.value !== null && String(option.value) !== "");
  };

  lookups.slmlookups = legacySlmLookups;

  if (!Array.isArray(lookups.firstNames) || lookups.firstNames.length === 0) {
    const firstNamesGroup = legacyCityscopeLookups.find(
      (item) => item?.look_up === "first_names"
    );
    lookups.firstNames = Array.isArray(firstNamesGroup?.list) ? firstNamesGroup.list : [];
  }

  // Legacy Street Type source fallback for environments where direct street types lookup is unavailable.
  if (!lookups.sourcecategoryOptions || lookups.sourcecategoryOptions.length === 0) {
    const sourceCategoryGroup = legacySlmLookups.find(
      (item) => item?.look_up === "source_category" || item?.look_up === "sourcecategory" || item?.look_up === "source_cat"
    );

    lookups.sourcecategoryOptions = mapLegacyLookupList(
      sourceCategoryGroup,
      ["value", "source_cat_id", "source_category_id", "id", "code", "name", "label"],
      ["label", "source_cat", "source_category", "name", "description", "code", "value"]
    );
  }

  if (!lookups.leasestatuscategoryOptions || lookups.leasestatuscategoryOptions.length === 0) {
    const leaseStatusGroup = legacySlmLookups.find(
      (item) => item?.look_up === "lease_status_category"
    );

    lookups.leasestatuscategoryOptions = mapLegacyLookupList(
      leaseStatusGroup,
      ["value", "lease_status_cat_id", "lease_status_category_id", "id", "code", "name", "label"],
      ["label", "lease_status_cat", "lease_status_category", "name", "description", "code", "value"]
    );
  }

  if (!lookups.broadspaceusecategoryOptions || lookups.broadspaceusecategoryOptions.length === 0) {
    const broadSpaceUseGroup = legacySlmLookups.find(
      (item) => item?.look_up === "broad_space_use"
    );

    lookups.broadspaceusecategoryOptions = mapLegacyLookupList(
      broadSpaceUseGroup,
      ["value", "broad_space_use_id", "id", "code", "name", "label"],
      ["label", "broad_space_use_code", "broad_space_use", "name", "description", "code", "value"]
    );
  }

  if (!lookups.leasemethodcategoryOptions || lookups.leasemethodcategoryOptions.length === 0) {
    const leaseMethodGroup = legacySlmLookups.find(
      (item) => item?.look_up === "lease_type_category"
    );

    lookups.leasemethodcategoryOptions = mapLegacyLookupList(
      leaseMethodGroup,
      ["value", "lease_type_cat_id", "lease_type_category_id", "id", "code", "name", "label"],
      ["label", "lease_type_cat", "lease_type_category", "lease_type", "name", "description", "code", "value"]
    );
  }

  // Legacy Street Type source fallback for environments where direct street types lookup is unavailable.
  if (!lookups.streetTypes || lookups.streetTypes.length === 0) {
    const streetTypeGroup = legacySlmLookups.find(
      (item) => item?.look_up === "street_type" || item?.look_up === "streettype"
    );

    lookups.streetTypes = mapLegacyLookupList(
      streetTypeGroup,
      ["value", "street_type_id", "id", "street_type", "code", "name", "label"],
      ["label", "street_type", "name", "description", "code", "value"]
    );
  }

  // Legacy Unit Type source fallback for environments where direct unit types lookup is unavailable.
  if (!lookups.unitTypes || lookups.unitTypes.length === 0) {
    const unitTypeGroup = legacySlmLookups.find(
      (item) => item?.look_up === "unit_type" || item?.look_up === "unittype"
    );

    lookups.unitTypes = mapLegacyLookupList(
      unitTypeGroup,
      ["value", "unit_type_id", "id", "unit_type", "code", "name", "label"],
      ["label", "unit_type", "name", "description", "code", "value"]
    );
  }

  // Legacy HOLD Reason source: /cityscopelookups where look_up === 'withholding'.
  if (!lookups.withholdingReasons || lookups.withholdingReasons.length === 0) {
    const withholdingGroup = legacyCityscopeLookups.find(
      (item) => item?.look_up === 'withholding'
    );

    const withholdingList = Array.isArray(withholdingGroup?.list)
      ? withholdingGroup.list
      : [];

    lookups.withholdingReasons = withholdingList.map((option) => {
      if (typeof option === 'string') {
        return { value: option, label: option };
      }

      const value =
        option?.value ??
        option?.withholding_reason_id ??
        option?.id ??
        option?.withholding_reason ??
        option?.reason ??
        '';

      const label =
        option?.label ??
        option?.withholding_reason ??
        option?.reason ??
        option?.name ??
        String(value);

      return {
        ...option,
        value,
        label,
      };
    });
  }

  // UAT sourced lift operator options from legacy cityscope lookups rather than /liftoperators.
  // Prefer that list when available so the dropdown matches the older environment and ordering.
  const legacyLiftOperatorGroup = legacyCityscopeLookups.find(
    (item) => item?.look_up === 'lift_operator' || item?.look_up === 'liftoperator'
  );

  const legacyLiftOperatorList = Array.isArray(legacyLiftOperatorGroup?.list)
    ? legacyLiftOperatorGroup.list
    : [];

  if (legacyLiftOperatorList.length > 0) {
    lookups.liftOperatorOptions = legacyLiftOperatorList
      .map((option) => {
        if (typeof option === 'string') {
          return { value: option, label: option };
        }

        const value =
          option?.value ??
          option?.entity_id ??
          option?.entity_id_lift_operator ??
          option?.lift_operator_id ??
          option?.id ??
          '';

        const label =
          option?.label ??
          option?.name ??
          option?.lift_operator ??
          option?.description ??
          String(value);

        return {
          ...option,
          value,
          label,
        };
      })
      .filter((option) => option.value !== undefined && option.value !== null && String(option.value) !== '');
  }

  // Legacy Review Type source fallback for environments where /slmlookups/reviewtypes
  // is unavailable or returns empty.
  if (!lookups.reviewTypeOptions || lookups.reviewTypeOptions.length === 0) {
    const reviewTypeGroup = legacyCityscopeLookups.find(
      (item) => item?.look_up === 'review_type' || item?.look_up === 'reviewtype'
    );

    const reviewTypeList = Array.isArray(reviewTypeGroup?.list)
      ? reviewTypeGroup.list
      : [];

    lookups.reviewTypeOptions = reviewTypeList
      .map((option) => {
        if (typeof option === 'string') {
          return { value: option, label: option };
        }

        const value =
          option?.value ??
          option?.review_type_code ??
          option?.code ??
          option?.id ??
          '';

        const label =
          option?.label ??
          option?.review_type ??
          option?.description ??
          option?.name ??
          String(value);

        return {
          ...option,
          value,
          label,
        };
      })
      .filter((option) => option.value !== undefined && option.value !== null && String(option.value) !== '');
  }

  // Legacy Broad Type source fallback for environments where /leaseclassifications
  // is unavailable or returns empty.
  if (!lookups.leaseClassificationOptions || lookups.leaseClassificationOptions.length === 0) {
    const leaseClassificationGroup = legacyCityscopeLookups.find(
      (item) => item?.look_up === 'lease_classification' || item?.look_up === 'leaseclassification'
    );

    const leaseClassificationList = Array.isArray(leaseClassificationGroup?.list)
      ? leaseClassificationGroup.list
      : [];

    lookups.leaseClassificationOptions = leaseClassificationList
      .map((option) => {
        if (typeof option === 'string') {
          return { value: option, label: option };
        }

        const value =
          option?.value ??
          option?.classification_code ??
          option?.code ??
          option?.id ??
          option?.classification ??
          '';

        const label =
          option?.label ??
          option?.classification ??
          option?.description ??
          option?.name ??
          String(value);

        return {
          ...option,
          value,
          label,
        };
      })
      .filter((option) => option.value !== undefined && option.value !== null && String(option.value) !== '');
  }

  if (!lookups.subRegionOptions || lookups.subRegionOptions.length === 0) {
    const subRegionGroup = legacySlmLookups.find(
      (item) => item?.look_up === 'sub_region'
    );

    const subRegionList = Array.isArray(subRegionGroup?.list)
      ? subRegionGroup.list
      : [];

    lookups.subRegionOptions = subRegionList.map((option) => {
      const value =
        option?.value ??
        option?.sub_region_id ??
        option?.id ??
        '';

      const label =
        option?.label ??
        option?.sub_region_name ??
        option?.name ??
        String(value);

      return {
        ...option,
        value,
        label,
      };
    });
  }

  // Determine global loading state
  const isLoading = results.some(result => result.isLoading);
  const isError = results.some(result => result.isError);

  return {
    lookups,
    isLoading,
    isError,
    // Add a refetch function to refresh all lookups if needed
    refetch: () => results.forEach(result => result.refetch()),rawResults: results,
    config: ALL_LOOKUP_QUERIES
  };
}